/**
 * @file
 *
 * Corrects legacy WordPress links that use the network's stored HTTP URL.
 */

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[href*="http://www.elon.edu/u/"]').forEach(link => {
		link.href = link.href.replace('http://www.elon.edu/u/', '/u/');
	});
});
